import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "Why should I partner with a custom CMS development company?",
    answer: `<p>Partnering with a custom CMS development company ensures you receive tailored solutions that align with your specific business needs, providing scalability, advanced security, and seamless integration with other systems.</p>`,
  },
  {
    question: "What are CMS website development services?",
    answer: `<p>CMS website development services encompass designing, building, and maintaining content management systems that allow businesses to easily create, edit, and manage website content without extensive technical knowledge.</p>`,
  },
  {
    question: "How does a CMS development company enhance website performance?",
    answer: `<p>A CMS development company optimizes website performance through efficient coding practices, streamlined content delivery, and robust backend management, ensuring faster load times and a smoother user experience.</p>`,
  },
  {
    question:
      "What benefits can a CMS development company offer for scalability?",
    answer: `<p>A CMS development company provides scalable solutions that grow with your business, allowing you to add new features, handle increased traffic, and expand your digital presence without compromising performance.</p>`,
  },
  {
    question: "How secure are solutions provided by a CMS development company?",
    answer: `<p>Solutions from a CMS development company are highly secure, incorporating advanced security measures such as data encryption, regular security updates, and vulnerability assessments to protect your content and user data.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>CMS Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
